import { Navigate, useLocation } from "react-router-dom";
import { LoadingScreen } from "@eduviaos/ui-kit";
import { useAuth } from "./AuthProvider";

/**
 * Route guard for authed-only pages. While the auth state is `loading`
 * we render a minimal placeholder rather than flashing the login screen
 * — the cookie-refresh round-trip on mount typically completes in <100ms
 * but a hard reload could surface it.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <LoadingScreen label="Restoring session…" />;
  }
  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
